import { type UseGetCollectOrderArgs } from "./hooks/use-get-collect-order";

export const collectOrderKeys = {
  all: ["collect-order"] as const,
  details: () => [...collectOrderKeys.all, "detail"] as const,
  detail: (params: UseGetCollectOrderArgs) =>
    [...collectOrderKeys.details(), params] as const
};
